module.exports = "/assets/site/images/dr_bozoky_anita.jpg?b2465f6413ecceae8d30fd3039a804c4";